/**
 * Arguments for NamingStrategyMetadata class.
 */
export interface NamingStrategyMetadataArgs {
    /**
     * Class to which this column is applied.
     */
    readonly target: Function

    /**
     * Strategy name.
     */
    readonly name: string
}
